import { h } from 'preact'
import { useEffect } from 'preact/compat'
import PropTypes from 'prop-types'
import { useController } from 'react-hook-form'
import { CARD_FIELDS } from '../../../../constants/card'
import Checkbox from '../../../Common/Checkbox'
import { useTranslations } from '../../../../hooks/useTranslations'

const SaveCard = ({ control, shouldSaveCard = false }) => {
  const l10n = useTranslations()

  const {
    field: { value, onChange, ...props },
  } = useController({
    name: CARD_FIELDS.saveCard,
    control,
  })

  useEffect(() => {
    onChange(shouldSaveCard)
  }, [shouldSaveCard])

  return (
    <Checkbox
      labelId="save-card-label"
      label={l10n.t('Save card details for next time')}
      labelProps={{
        onKeyDown: e => {
          if (e.code === 'Space') {
            e.preventDefault()
            onChange(!value)
          }
        },
        'data-testid': 'save-card-checkbox-label',
      }}
      inputProps={{
        'data-testid': 'save-card-checkbox',
        id: 'save-card-checkbox',
        onInput: onChange,
        checked: value,
        ...props,
      }}
    />
  )
}

SaveCard.propTypes = {
  control: PropTypes.object.isRequired,
  shouldSaveCard: PropTypes.bool,
}

export default SaveCard
